<template>
	<!-- app user menu -->
	<div>
		<b-dropdown id="dropdown_user_notif" variant="outline-success" no-caret>

			<template v-slot:button-content>
				<div :title="user.name"
					 class="header-icon d-flex align-items-center justify-content-center ml-2 js-waves-off">

					<picture v-if="parseInt(user.id) > 0">
						<source :srcset="user_avatar_template | get_image_from_template(60,60,'webp')"
								type="image/webp"/>
						<source :srcset="user_avatar_template | get_image_from_template(60,60,'png')"
								type="image/png"/>
						<img :src="user_avatar_template | get_image_from_template(60,60,'png')" alt=""
							 class="profile-image rounded-circle"/>
					</picture>

					<img src="/templates/imc_docs/images/icons/user_profile.png"
						 class="profile-image rounded-circle"
						 alt="Contact Person" v-else>
				</div>
			</template>

			<b-dropdown-form>
				<div class="">
					<div class="dropdown-header bg-trans-gradient d-flex flex-row py-4 rounded-top">
						<div class="d-flex flex-row align-items-center mt-1 mb-1 color-white">
							<div class="info-card-text">
								<div class="fs-lg text-truncate text-truncate-lg">
									{{ user.name }}
								</div>
								<span class="text-truncate text-truncate-md opacity-80">
                                    {{ user.email }}
                                </span>
							</div>
						</div>
					</div>

					<div class="dropdown-divider m-0"></div>
					<a href="/profile" class="dropdown-item">
                        <span data-i18n="drpdwn.reset_layout">
                            Мій кабінет
                        </span>
					</a>

					<div class="dropdown-divider m-0"></div>
					<a href="#" class="dropdown-item" data-action="app-fullscreen">
                        <span data-i18n="drpdwn.fullscreen">
                            Повноекраний режим
                        </span>
						<i class="float-right text-muted fw-n">F11</i>
					</a>
					<a href="#" class="dropdown-item" data-action="app-print">
						<span data-i18n="drpdwn.print">Друкувати</span>
						<i class="float-right text-muted fw-n">Ctrl + P</i>
					</a>
					<div class="dropdown-divider m-0"></div>

					<a class="dropdown-item fw-500 pt-3 pb-3" @click.stop.prevent="logout">
						<span data-i18n="drpdwn.page-logout">Вихід</span>
					</a>
				</div>
			</b-dropdown-form>


		</b-dropdown>

	</div>
</template>

<script>
import {createHelpers} from 'vuex-map-fields';

const {mapFields} = createHelpers({
	getterType: 'user/getUserField',
	mutationType: 'user/updateUserField',
});

export default {
	name: "user_app_profile",

	methods: {
		async logout() {
			IMC_CORE.showloading()
			await portal_api.post('/internal/auth.logout').then(({data}) => {
				IMC_CORE.hideloading()
				if (data.status == "operation_success") {
					window.location.reload();
				}
			}).catch(err => {
				IMC_CORE.hideloading()
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
			});
		}
	},

	computed: {
		...mapFields([
			'user'
		]),

		user_avatar() {
			try {
				if (this.user.id > 0) {
					if (this.user.hasOwnProperty('avatar')) {
						return this.user.avatar;
					}
				}
			} catch (e) {

			}
			return null;
		},

		user_avatar_template() {
			if (this.user_avatar.hasOwnProperty('template')) {
				return this.user_avatar.template;
			}

			return "";
		},

		get_image_png() {
			if (this.user_avatar_template) {
				return this.user_avatar_template
					.replace("{webp|jpeg|png}", 'png')
					.replace("{width}", "60")
					.replace("{height}", "60");
			}
			return "";
		},
		get_image_webp() {
			if (this.user_avatar_template) {
				return this.user_avatar_template
					.replace("{webp|jpeg|png}", 'webp')
					.replace("{width}", "60")
					.replace("{height}", "60");
			}
			return "";
		},
	},


}
</script>

<style scoped>

</style>
